module.exports = __webpack_public_path__ + "static/media/media-03.c3898b70.png";